import React from 'react';
import PropTypes from 'prop-types';

import stylePropType from 'react-style-proptype';

import { Button, Card, CardActions, CardText, CardTitle } from 'react-md';

import './DashboardCardQuotations.scss';

const themes = ['white', 'red', 'blue', 'green', 'orange', 'yellow', 'purple', 'grey'];
const quotationsItemShape = { value: PropTypes.string, label: PropTypes.string };
const actionItemShape = { route: PropTypes.string, labelBtn: PropTypes.string };

class DashboardCardQuotations extends React.PureComponent {
  handleRoute = ({ route, query }) => {
    const { onRoute } = this.props;
    onRoute({ route, query });
  };

  render() {
    const { style, theme, title, subtitle, action, quotations, strings } = this.props;

    const rows = (
      <div className="card quotation">
        <div className="rows">
          <div
            className="row small red"
            onKeyPress={() => this.handleRoute({ route: quotations.hot.route, query: quotations.hot.query })}
            onClick={() => this.handleRoute({ route: quotations.hot.route, query: quotations.hot.query })}
            role="link"
            tabIndex={0}
          >
            <span className="value">{quotations.hot.value}</span>
            <span className="label">{strings[quotations.hot.label] || quotations.hot.label}</span>
          </div>
          <div
            className="row small purple"
            onKeyPress={() =>
              this.handleRoute({
                route: quotations.lukewarm.route,
                query: quotations.lukewarm.query,
              })
            }
            onClick={() =>
              this.handleRoute({
                route: quotations.lukewarm.route,
                query: quotations.lukewarm.query,
              })
            }
            role="link"
            tabIndex={0}
          >
            <span className="value">{quotations.lukewarm.value}</span>
            <span className="label">{strings[quotations.lukewarm.label] || quotations.lukewarm.label}</span>
          </div>
          <div
            className="row small blue"
            onKeyPress={() => this.handleRoute({ route: quotations.cold.route, query: quotations.cold.query })}
            onClick={() => this.handleRoute({ route: quotations.cold.route, query: quotations.cold.query })}
            role="link"
            tabIndex={0}
          >
            <span className="value">{quotations.cold.value}</span>
            <span className="label">{strings[quotations.cold.label] || quotations.cold.label}</span>
          </div>
        </div>
      </div>
    );

    return (
      <Card style={style} className={`dashboard-card-quotations ${theme}`}>
        <CardTitle title={strings[title] || title} subtitle={strings[subtitle] || subtitle} />
        <CardText>{rows}</CardText>
        <CardActions className="md-divider-border md-divider-border--top">
          <Button flat secondary onClick={() => this.handleRoute({ route: action.route, query: action.query })}>
            {strings[action.labelBtn] || action.labelBtn}
          </Button>
        </CardActions>
      </Card>
    );
  }
}
DashboardCardQuotations.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  style: stylePropType,
  strings: PropTypes.objectOf(PropTypes.string),
  theme: PropTypes.oneOf(themes),
  action: PropTypes.shape(actionItemShape),
  quotations: PropTypes.shape(quotationsItemShape),
  onRoute: PropTypes.func,
};

DashboardCardQuotations.defaultProps = {
  subtitle: '',
  theme: 'white',
  style: { minWidth: '250px' },
  strings: {},

  quotations: {
    hot: { value: '8', label: 'quotation.hot.label', route: '/quotations/hot' },
    lukewarm: { value: '58', label: 'quotation.lukewarm.label', route: '/quotations/lukewarm' },
    cold: { value: '587', label: 'quotations.cold.label', route: '/quotations/cold' },
  },
  action: {
    labelBtn: 'action.labelBtn.start',
    route: '/quotations/new',
  },
  onRoute: route => {
    console.log('onRoute::', route); // eslint-disable-line
  },
};

export default DashboardCardQuotations;
